<template>
  <div class="star-rating">
    <div
      v-for="(_, i) in Array.from(Array(max))"
      :key="i"
      class="star"
      :style="{'--i': i}"
    />
  </div>
</template>

<script setup>

const props = defineProps({
  max: {
    type: Number,
    required: false,
    default: 5,
  },
  note: {
    type: Number,
    required: false,
    default: 1,
  },
});

</script>

<style lang="scss" scoped>
.star-rating {
  display: flex;
  gap: 0.25rem;

  .star {
    width: 1.5rem;
    height: 1.5rem;
    background: var(--solid-06);
    mask-image: url("../assets/svg/func_star-solid.svg");
    mask-size: contain;

    &::before {
      content: '';
      position: absolute;
      top: 0; left: 0;
      height: 100%;
      width: calc(100% * min(1, v-bind(note) - var(--i)));
      background-color: #FFB11B;
    }
  }
}
</style>
